<p>callback works!</p>

<p>
    {{isLoggedIn}}
</p>

<pre *ngIf="auths.userProfile$ | async as profile">
    <code>{{ profile | json }}</code>
    </pre>